/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
// INTERFACES
import { LeadingZeroeInterface } from "../../interfaces/LeadingZeroes.interface";

export interface LeadingZeroeState {
	leadingZeroe: LeadingZeroeInterface;
	openDrawer: boolean;
	openForm: boolean;
	refreshTable: boolean;
	formAction: string;
	openModalDelete: boolean;
}

const initialState: LeadingZeroeState = {
	leadingZeroe: {
		id: "",
		name: "",
		from_device_serial: false,
		refresh_all: false,
		reinitialize_all_devices: false,
		rvu: false,
		set_one_bit: false,
		set_one_byte: false,
	},
	openDrawer: false,
	openForm: false,
	refreshTable: false,
	formAction: "CREATE",
	openModalDelete: false,
};

export const leadingZeroeSlice = createSlice({
	name: "leadingZeroe",
	initialState,
	reducers: {
		updateLeadingZeroe: (state, action: PayloadAction<LeadingZeroeInterface>) => {
			state.leadingZeroe = action.payload;
		},
		updateOpenDrawer: (state, action: PayloadAction<boolean>) => {
			state.openDrawer = action.payload;
		},
		updateOpenForm: (state, action: PayloadAction<boolean>) => {
			state.openForm = action.payload;
		},
		updateRefreshTable: (state, action: PayloadAction<boolean>) => {
			state.refreshTable = action.payload;
		},
		updateFormAction: (state, action: PayloadAction<string>) => {
			state.formAction = action.payload;
		},
		updateOpenModalDelete: (state, action: PayloadAction<boolean>) => {
			state.openModalDelete = action.payload;
		},
	},
});

// Action creators are generated for each case reducer function
export const {
	updateLeadingZeroe,
	updateOpenDrawer,
	updateOpenForm,
	updateRefreshTable,
	updateFormAction,
	updateOpenModalDelete,
} = leadingZeroeSlice.actions;

export default leadingZeroeSlice.reducer;
